'use client';
import React from 'react';
import { motion } from 'framer-motion';

import { businessData } from '@/config/businessData';

const WhatsAppButton = () => {
    // Phone number from centralized config
    const phoneNumber = businessData.contact.phoneLink.replace('+', '');
    // Pre-filled message
    const message = encodeURIComponent("Hi, I'm interested in your label services.");
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-[9999] flex items-center justify-center p-2"
            aria-label="Chat on WhatsApp"
        >
            <motion.div
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ type: "spring", stiffness: 260, damping: 20, delay: 1 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="bg-[#25D366] hover:bg-[#20b858] text-white p-2 md:p-3.5 rounded-full shadow-[0_4px_12px_rgba(0,0,0,0.3)] flex items-center justify-center transition-colors duration-300 relative group"
            >
                {/* Ping animation effect */}
                <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366] opacity-75 duration-3000"></span>

                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                    alt="WhatsApp"
                    className="relative z-10 w-5 h-5 md:w-9 md:h-9"
                />

                {/* Tooltip on hover */}
                <span className="absolute right-full mr-4 bg-white text-gray-800 text-xs font-bold py-1.5 px-3 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap hidden md:block">
                    Chat with us
                </span>
            </motion.div>
        </a>
    );
};

export default WhatsAppButton;
